import { Injectable } from '@angular/core';
import { PATH_PAGE_ITERATION_SYMBOL } from '@workflow/class/stateful-value.class';
import { LogicFnContext } from '@workflow/service/logic/logic.service';

@Injectable({
  providedIn: 'root'
})
export class OlaUtilitiesService {
  // get bool result if value exists.
  // bool values will always be true.
  public hasValue(value): boolean {
    return (
      value !== null &&
      value.toString() !== 'null' &&
      value !== undefined &&
      value.toString() !== 'undefined' &&
      value.toString().trim().length > 0
    );
  }
}

/**
 * Replace page iterative literal with numeric index
 * @param configId storageId path with or without iterative tokens #
 * @param arg1 can be replacement index or logic fn context
 */
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export const processPath = (configId: string, arg1?: number | LogicFnContext): string => {
  if (configId.indexOf(PATH_PAGE_ITERATION_SYMBOL) < 0) {
    return configId;
  }
  const pageIterationId = typeof arg1 === 'number' ? arg1 : getPageIterationId(arg1);
  if (pageIterationId == null) {
    throw new Error(`Unable to determine iterationId for config: ${configId}.`);
  }
  return configId.replace(PATH_PAGE_ITERATION_SYMBOL, String(pageIterationId));
};

/**
 * Check and returns empty string for primary and interpreted prefix with numeric index i for co-borrower 'coBorrower/i/'
 * @param context context for path interpretation
 */
export const coAppSwitch = (context: LogicFnContext): string =>
  context.field.config.id.indexOf(PATH_PAGE_ITERATION_SYMBOL) > -1 ? processPath('coBorrowers/#/', context) : '';

/**
 * Replace # in config id with pageIterationId
 */
export const getPageIterationId = (context: LogicFnContext): number => {
  const ref = context && (context.field || context.card || context.page || context.value);
  return ref && ref.pageIterationId;
};
